import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Bell, BellRing } from "lucide-react";
import { useCustomer } from "../CustomerContext";
import { addStockAlert, listStockAlerts } from "../../lib/stockAlertsApi";

// T66: Out of Stock / Temporarily Unavailable -> one email when it's purchasable again. Guests sign in, then return here.
export function NotifyMe({ p }) {
  const { customer } = useCustomer();
  const nav = useNavigate();
  const loc = useLocation();
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!customer) return;
    listStockAlerts().then((a) => setOn(a.some((x) => x.product_id === p.id && x.status === "waiting"))).catch(() => {});
  }, [customer, p.id]);
  const go = async () => {
    if (!customer) { nav(`/account/auth?next=${encodeURIComponent(loc.pathname)}`); return; }
    try { await addStockAlert(p.id); setOn(true); toast.success("We'll email you once when it's back in stock."); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't set the alert."); }
  };
  return (
    <button type="button" onClick={go} disabled={on} aria-pressed={on} data-testid="product-notify-me" data-state={on ? "on" : "off"}
      className="flex h-12 flex-1 items-center justify-center gap-2 rounded-full bg-[var(--brand-primary)] px-6 font-bold text-white transition-colors hover:opacity-90 disabled:bg-emerald-700">
      {on ? <BellRing size={18} aria-hidden="true" /> : <Bell size={18} aria-hidden="true" />}
      {on ? "We'll email you when it's back" : customer ? "Notify me" : "Sign in to get notified"}
    </button>
  );
}
